import React, { useRef } from 'react'
import axios from '../../axios'
import { ENDPOINTS } from '../../constants'
import { getAccessSuspendedMessage } from '../../suspendedBrandsRegistry'
import { errorToast } from '../../../utils/errToast'

interface SocialShareLinkProps {
  children: React.ReactNode
  onInitial: Function
  onSuccess: Function
  onFail?: Function
  shortenedLink: string
  shortLinkData: any
  isLoggedIn: boolean
  needsDeclaration?: boolean
  onDeclarationRequired?: Function
}

const SocialShareLink = ({
  children,
  onInitial,
  onSuccess,
  onFail,
  shortenedLink,
  shortLinkData,
  isLoggedIn,
  needsDeclaration,
  onDeclarationRequired,
}: SocialShareLinkProps) => {
  const ref = useRef(null)

  const handleCreateShareLink = async () => {
    try {
      if (isLoggedIn) {
        if (shortenedLink) {
          ref.current.click()
        } else if (needsDeclaration) {
          onDeclarationRequired?.()
        } else {
          onInitial()
          let refinedURL
          let productURL = new URL(shortLinkData.url)
          if (
            productURL.host === 'www.containerstore.com' &&
            productURL.search.includes('q=')
          ) {
            productURL.search.split('&').forEach(param => {
              if (param.includes('productId')) {
                refinedURL =
                  productURL.origin + productURL.pathname + '?' + param
              }
            })
          } else {
            refinedURL = shortLinkData.url
          }
          shortLinkData.url = refinedURL
          const shortenedValue = await axios.post(
            ENDPOINTS.shortenLink,
            shortLinkData,
            { params: { source: 'website' } }
          )
          const { data } = shortenedValue.data
          if (data && data.shortUrl?.length > 0) {
            onSuccess(data)
            setTimeout(() => ref.current.click(), 0)
          }
        }
      } else {
        onFail?.()
      }
    } catch (err) {
      const suspendedMessage = getAccessSuspendedMessage(err)
      if (suspendedMessage) errorToast(suspendedMessage)
    }
  }

  return (
    <div onClick={handleCreateShareLink}>{children(ref, shortenedLink)}</div>
  )
}

export default SocialShareLink
